export const findNodeById = (nodeMap, nodesSource, id, groupId) => {
    let node = nodeMap.get(id);
    if (node)
        return { node, isGroup: false, tag: node.tag };
    if (groupId) {
        node = nodeMap.get(groupId);
        if (node) {
            return { node, isGroup: true, tag: node.tag };
        }
    }
    const source = nodesSource[id];
    if (source === null || source === void 0 ? void 0 : source.GroupId) {
        node = nodeMap.get(source.GroupId);
        if (node) {
            return { node, isGroup: true, tag: node.tag };
        }
    }
    return {
        node: undefined,
        isGroup: false,
        tag: undefined
    };
};
